<script setup lang="ts">
import Marquee from '@/components/Marquee.vue';
import { ref, onMounted, nextTick } from 'vue';

type Props = {
    words1: string[],
    words2: string[],
}
const props = defineProps<Props>();
const words1 = ref<string[]>(props.words1)
const words2 = ref<string[]>(props.words2)


const marqueeOne = ref<any>(null)
const marqueeTwo = ref<any>(null)


const toggle1 = () => {
    if (marqueeOne.value.state() === 'running') {
        marqueeOne.value.pause()
    } else {
        marqueeOne.value.play()
    }
}
const toggle2 = () => {
    if (marqueeTwo.value.state() === 'running') {
        marqueeTwo.value.pause()
    } else {
        marqueeTwo.value.play()
    }
}
onMounted(() => {

})

</script>
<style scoped lang="scss">

</style>
<template>
    <Marquee :words="words1" :speed="30" ref="marqueeOne" @click="toggle1">
        <template #="{ text, index }">
            <div :class="{ word: true, odd: index % 2 === 0 }">{{ text }}</div>
        </template>
    </Marquee>
    <Marquee :words="words2" reverse :speed="30" ref="marqueeTwo" @click="toggle2">
        <template #="{ text, index }">
            <div :class="{ word: true, odd: index % 2 === 0 }">{{ text }}</div>
        </template>
    </Marquee>
</template>